import { ActualityHqDataColumn } from '@warebee/shared/dataset-queries';
import { ActualityAggregatedHqExtendedStatsDataColumn } from './actuality.kpi.types';
import { ActualityExtraSettings } from './actuality.types';

export const actualityExtraSettingsDefault: ActualityExtraSettings = {
  autoRefresh: false,
  refreshInterval: 5,
  assignmentExtraFields: [],
  activityExtraFields: [],
  assignmentMetricDescriptors: [],
  actualityMetricDescriptors: [],
};

// Default visible event issues - these are the most important issues to show by default
export const defaultVisibleEventIssues: string[] = [
  'idleTime',
  'congestedTime',
  'locationAssignmentIssue',
  'outOfSequencePick',
  'locationNotFound',
  'analyseIssue',
];

// Default visible device indicators - these are the device status indicators to show by default
export const defaultVisibleDeviceIndicators: string[] = [
  'agentEnergy',
  'agentSignalStrength',
];

export const actualityDisabledAgentStatsFieldsDefault: ActualityAggregatedHqExtendedStatsDataColumn[] =
  [
    // 'ordersCount',

    // 'breaks',
    // 'meetings',
    // 'training',
    // 'recharge',
    // 'misc',
    // 'maintenance',

    // 'shiftsCount',

    // 'perShiftLinesPerformance',
    // 'perShiftOrdersPerformance',
    // 'perShiftJobsPerformance',
    // 'perShiftLocationsPerformance',
    // 'perShiftUomsPerformance',

    // 'shiftScheduledOrdersPerformance',
    // 'shiftScheduledJobsPerformance',
    // 'shiftScheduledUomsPerformance',
    // 'shiftScheduledLocationsPerformance',
    // 'shiftScheduledLinesPerformance',

    // 'shiftActualOrdersPerformance',
    // 'shiftActualJobsPerformance',
    // 'shiftActualLocationsPerformance',
    // 'shiftActualUomsPerformance',
    // 'shiftActualLinesPerformance',

    'grossOrdersPerformance',
    'grossLinesPerformance',
    'grossUomsPerformance',
    'grossLocationsPerformance',
    'grossJobsPerformance',

    'netLinesPerformance',
    'netUomsPerformance',
    'netLocationsPerformance',
    'netOrdersPerformance',

    // 'shiftDirectLinesPerformance',
    // 'shiftDirectUomsPerformance',
    // 'shiftDirectLocationsPerformance',
    // 'shiftDirectJobsPerformance',
    // 'shiftDirectOrdersPerformance',

    // 'shiftScheduledTime',
    // 'efficiencyShiftHours',
    // 'fullTimeEquivalents',
    'idleNetRatio',
    'netGrossRatio',
    // 'activeShiftRatio',
    // 'utilisationScheduledRatio',
    'linesPerVisitedLocation',
    'uomsPerVisitedLocation',

    'locationsPerJob',
    'locationsPerOrder',

    'totalVolume',
    'totalWeight',
    // 'totalCost',

    // 'totalDistanceInternal',
    // 'totalDistanceStartEnd',
    // 'totalDistance',
    'totalDistancePerLine',
    'totalDistancePerOrder',
    'totalDistancePerJob',

    'internalDistancePerLine',
    'internalDistancePerOrder',
    'internalDistancePerJob',

    'durationDiff',
    'durationRate',
    // 'netCost',
    'costPerUnit',

    // 'fteScheduled',
    // 'fteActual',
    // 'fteDirect',
  ];

export const actualityAggregatedMetricsDefault: ActualityAggregatedHqExtendedStatsDataColumn[] =
  [
    'eventsCount',
    'uomCount',
    'visitsCount',
    'uomLineRatio',
    'jobLineRatio',
    'analyzedDistance',
    'idleTimeMs',
  ];

export const actualityJobGroupFields: ActualityHqDataColumn[] = [
  'jobId',
  'agentId',
  'agentType',
  'eventProcessType',
];
